module.exports = __webpack_public_path__ + "img/room-creative-award_ar.a72def53.png";